import { Dictionary } from '../../../../../types/dictionary';

export interface TemplateLocationParameters<T> {
  pathParams?: Dictionary<unknown>;
}
